import { j as r } from "../jsx-runtime-Wav_3Wde.js";
import { s as m } from "../index.esm-DOxVcNnO.js";
import { Children as g, cloneElement as j, isValidElement as y } from "react";
import { styled as n } from "styled-components";
import { space as w } from "styled-system";
import { Flex as L, Box as C } from "../Flexbox/Flexbox.mjs";
import "../Icon/StyledPath.mjs";
import I from "../Icon/Icons/DiscIcon.mjs";
const s = (o) => o.components.list, S = /* @__PURE__ */ n.ul.withConfig({
  shouldForwardProp: (o) => m(o)
}).withConfig({
  componentId: "sc-fded761f-0"
})([
  "",
  " ",
  ""
], ({ theme: o }) => s(o).base, w), F = /* @__PURE__ */ n.ol.withConfig({
  shouldForwardProp: (o) => m(o)
}).withConfig({
  componentId: "sc-fded761f-1"
})([
  "",
  ""
], ({ theme: o }) => s(o).ordered), q = /* @__PURE__ */ n.li.withConfig({
  shouldForwardProp: (o) => m(o)
}).withConfig({
  componentId: "sc-fded761f-2"
})([
  "",
  " ",
  ""
], ({ theme: o }) => s(o).listItem, w), E = /* @__PURE__ */ n(C).withConfig({
  componentId: "sc-fded761f-3"
})([
  "",
  ""
], ({ theme: o }) => s(o).iconWrapper), P = /* @__PURE__ */ n.span.withConfig({
  componentId: "sc-fded761f-4"
})([
  "",
  ""
], ({ theme: o }) => s(o).icon), l = 24, k = ({ children: o, iconColor: i = "currentColor", Icon: d = I, variant: e = "unordered", ...p }) => /* @__PURE__ */ r.jsx(q, {
  "data-qa-id": "list-item",
  variant: e,
  ...p,
  children: /* @__PURE__ */ r.jsxs(L, {
    children: [
      e === "unordered" && /* @__PURE__ */ r.jsx(E, {
        width: l,
        flexShrink: 0,
        "data-qa-id": "list-icon-wrapper",
        children: /* @__PURE__ */ r.jsx(P, {
          size: l,
          as: d,
          color: i,
          "data-qa-id": "list-icon"
        })
      }),
      /* @__PURE__ */ r.jsx(C, {
        flexGrow: 1,
        children: o
      })
    ]
  })
}), N = ({ children: o, iconColor: i = "currentColor", Icon: d = I, variant: e = "unordered", ...p }) => {
  const x = e === "ordered" ? F : S;
  return /* @__PURE__ */ r.jsx(x, {
    "data-qa-id": "list",
    ...p,
    children: o && g.map(o, (t, u) => {
      var a, f, c;
      return /* @__PURE__ */ y(t) && t.type === k ? /* @__PURE__ */ j(t, {
        key: u,
        Icon: ((a = t == null ? void 0 : t.props) == null ? void 0 : a.Icon) ?? d,
        iconColor: ((f = t == null ? void 0 : t.props) == null ? void 0 : f.iconColor) ?? i,
        variant: ((c = t == null ? void 0 : t.props) == null ? void 0 : c.variant) ?? e
      }) : t;
    })
  });
};
export {
  N as List,
  k as ListItem
};
